export default "__VITE_ASSET__DXTtHp6D__"